module.exports = __webpack_public_path__ + "img/20170704_135648_091.6516054f.jpg";